import { render, staticRenderFns } from "./pnl.component.vue?vue&type=template&id=2304b972&scoped=true"
import script from "./pnl.component.vue?vue&type=script&lang=js"
export * from "./pnl.component.vue?vue&type=script&lang=js"
import style0 from "./pnl.component.vue?vue&type=style&index=0&id=2304b972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304b972",
  null
  
)

export default component.exports